import Experiments from 'types/Experiments';

export default function useExperiment(flagKey: keyof Experiments) {
  // experiments can be undefined on rspec
  const experiment = __AT_DATA__.experiments?.[flagKey] ?? ({} as Record<string, never>);

  if (typeof window !== 'undefined') {
    global.fetch('https://api2.amplitude.com/2/httpapi', {
      body: JSON.stringify({
        api_key: __AT_DATA__.amplitudeApiKey,
        events: [
          {
            device_id: __AT_DATA__.amplitudeDeviceId,
            event_type: '$exposure',
            event_properties: { flag_key: flagKey, variant: experiment.value }
          }
        ]
      }),
      method: 'post'
    });
  }

  return experiment;
}
